import type { PageFormat } from '@tiptap-pro/extension-pages'
import { cmToPixels } from '@tiptap-pro/extension-pages'
import { coverDimensions, amazonCoverDimensions, kindleCoverDimensions } from '@/constants/coverDimensions'
import type { TCoverSize, TAmazonCoverSize } from '@/types/cover.ts'

// Force 96 DPI to ensure consistent dimensions across browsers
// TipTap's cmToPixels defaults to 96 * devicePixelRatio which varies by display
const FIXED_DPI = 96

export const DEFAULT_MARGINS = {
  top: Math.ceil(cmToPixels(2.54, FIXED_DPI)),
  right: Math.ceil(cmToPixels(2, FIXED_DPI)),
  bottom: Math.ceil(cmToPixels(2.54, FIXED_DPI)),
  left: Math.ceil(cmToPixels(2, FIXED_DPI)),
}

export const DEFAULT_PAGE_FORMAT: PageFormat = {
  id: 'A4',
  width: 794,
  height: 1123,
  margins: DEFAULT_MARGINS,
}

/**
 * Get a PageFormat by dimension name (e.g., 'A4', '6x9', 'Letter').
 * Converts mm dimensions to pixels and applies default margins.
 * Returns default A4 format if dimension name not found.
 */
export function getPageFormatByName(name: string): PageFormat {
  let dimension: TCoverSize | TAmazonCoverSize | undefined = amazonCoverDimensions.find((d) => d.name === name)
  if (!dimension) {
    dimension = coverDimensions.find((d) => d.name === name)
  }
  if (!dimension && name.toLowerCase() === 'kindle') {
    dimension = kindleCoverDimensions
  } else if (!dimension) {
    return DEFAULT_PAGE_FORMAT
  }

  return {
    id: dimension.name,
    width: Math.ceil(cmToPixels(dimension.width / 10, FIXED_DPI)),
    height: Math.ceil(cmToPixels(dimension.height / 10, FIXED_DPI)),
    margins: DEFAULT_MARGINS,
  }
}
